"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME_INDEPENDENT_FN_NAMES = exports.TIME_DEPENDENT_FN_NAMES = void 0;
/**
 * Public API function names expected to be available in the Client Profiler
 * instances.
 *
 * @warning Don't try to dynamically retrieve these the core ClientProfiler
 *   class to avoid inadvertently bundling the full core package.
 * @todo Create unit tests to validate we're capturing all member function names
 *   from the core ClientProfiler class (PERF-872)
 */
var TIME_INDEPENDENT_FN_NAMES = exports.TIME_INDEPENDENT_FN_NAMES = ['beacon', 'profileIntervalFail', 'registerEvent', 'registerEvents', 'registerPage', 'isRegistered'];
var TIME_DEPENDENT_FN_NAMES = exports.TIME_DEPENDENT_FN_NAMES = ['profile', 'profileIntervalBegin', 'profileIntervalEnd'];